<template>
  <div class="gold-border-wrapper p-[3px]!" id="header-banner">
    <div
      class="relative rounded-xl w-full h-[100px] flex items-center justify-center overflow-hidden"
    >
      <!-- blurred background image -->
      <sc-image
        :media="fields.image"
        class="absolute inset-0 w-full h-full object-cover filter blur-[1px] z-0"
      />

      <!-- translucent white gradient overlay from left -->
      <div class="absolute inset-0 z-10 pointer-events-none banner-gradient" aria-hidden="true" />

      <!-- title/text on top -->
      <span
        class="text-white text-3xl font-serif font-bold absolute inset-0 w-full h-full flex items-center justify-start px-4 z-20"
      >
        <sc-text :field="fields.title" class="title" />
      </span>
    </div>
  </div>
  <div class="flex mb-1 intro items-center ml-2 mr-2" id="header-introduction">
    <sc-text tag="p" :field="fields.introduction" />
  </div>
</template>

<script>
import { Image as ScImage, Text as ScText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'HeaderBanner',
  props: {
    rendering: {
      type: Object,
      required: true,
    },
  },
  components: {
    'sc-image': ScImage,
    'sc-text': ScText,
  },
  computed: {
    fields() {
      // rendering.fields are populated from route YAML (disconnected)
      // or from Layout Service (integrated)
      return this.rendering?.fields || {};
    },
    imageUrl() {
      const img = this.fields?.image || {};
      // try common shapes used by disconnected/layout service
      return img.src || (img.value && img.value.src) || (img.fields && img.fields.src) || '';
    },
  },
};
</script>

<style scoped>
.banner-gradient {
  background:
    linear-gradient(97deg, rgba(255, 255, 255, 0.6) 0.13%, rgba(255, 255, 255, 0) 64.91%),
    rgba(1, 56, 141, 0.2);
  background-repeat: no-repeat;
  background-size: cover;
}

.title {
  text-shadow:
    0 0 8px rgba(1, 17, 47, 0.5),
    0 0 16px #01112f;
}
</style>
